<script setup>
/**
 * @fileoverview ConsoleSessionDock — floating re-entry control for minimized consoles.
 *
 * When the console host overlay is visible, session switching lives in
 * ConsoleToolbar (ConsoleSessionTabs). This component only renders the
 * bottom-right floating stack while sessions are minimized (`!isHostVisible`).
 */
import { computed } from 'vue'
import { useConsoleSessionsStore } from '@/stores/consoleSessions'
import ConsoleSessionTabs from './ConsoleSessionTabs.vue'

const sessionsStore = useConsoleSessionsStore()

const sessions = computed(() => sessionsStore.sessionList)
const isHostVisible = computed(() => sessionsStore.isHostVisible)

const showFloating = computed(() => sessions.value.length > 0 && !isHostVisible.value)
</script>

<template>
  <Teleport to="body">
    <div
      v-if="showFloating"
      class="console-session-dock mode-floating"
      role="presentation"
    >
      <ConsoleSessionTabs variant="dock" />
    </div>
  </Teleport>
</template>

<style scoped>
.console-session-dock.mode-floating {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 60;
  display: flex;
  flex-direction: column;
  width: min(100vw - 2rem, 22rem);
  max-height: min(70vh, 28rem);
  overflow-y: auto;
  padding: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid rgb(229 231 235);
  background: rgb(255 255 255 / 0.97);
  box-shadow:
    0 10px 15px -3px rgb(0 0 0 / 0.08),
    0 4px 6px -4px rgb(0 0 0 / 0.06);
}

.dark .console-session-dock.mode-floating {
  border-color: rgb(51 65 85);
  background: rgb(15 23 42 / 0.97);
  box-shadow:
    0 10px 15px -3px rgb(0 0 0 / 0.35),
    0 4px 6px -4px rgb(0 0 0 / 0.25);
}
</style>
